<template>
  <v-navigation-drawer
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <v-list>
      <v-list-group
        v-for="(submenu, title) in filteredSubmenuItems"
        :key="title"
        @click="toggleSubmenu(title)"
      >
        <template v-slot:activator="{ props }">
          <v-list-item v-bind="props">
            <v-list-item-title>{{ title }}</v-list-item-title>
          </v-list-item>
        </template>

        <template v-for="subitem in submenu.items" :key="subitem.route">
          <!-- Si tiene submenú -->
          <v-list-group v-if="subitem.items?.length" sub-group>
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props">
                {{ subitem.text }}
              </v-list-item>
            </template>

            <v-list-item
              v-for="childItem in subitem.items"
              :key="childItem.route"
              :to="childItem.route"
            >
              {{ childItem.text }}
            </v-list-item>
          </v-list-group>

          <!-- Si no tiene submenú -->
          <v-list-item
            v-else
            :to="subitem.route"
            @click="subitem.action && handleAction(subitem.action)"
          >
            {{ subitem.text }}
          </v-list-item>
        </template>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { reactive, computed } from 'vue'
import { OPCIONES_MENU } from '@/utils/opcionesMenu'
import { useReportesStore } from '@/stores/reportesStore'

defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

defineEmits({
  'update:modelValue': (value) => typeof value === 'boolean'
})

const submenuItems = reactive(OPCIONES_MENU)

const toggleSubmenu = (title) => {
  if (submenuItems[title]) {
    submenuItems[title].visible = !submenuItems[title].visible
  }
}

const filteredSubmenuItems = computed(() => {
  return Object.entries(submenuItems).reduce((acc, [key, submenu]) => {
    if (submenu.permission) {
      acc[key] = {
        ...submenu,
        items: submenu.items.filter((item) => item.permission)
      }
    }
    return acc
  }, {})
})

const reportesStore = useReportesStore()

const handleAction = async (action) => {
  switch (action) {
    case 'imprimirReporteCaja':
      await reportesStore.imprimirReporteCaja()
      break
    // Aquí puedes agregar más casos para otras acciones
  }
}
</script>
